import { FormGroup, AbstractControl } from '@angular/forms';

export class TopForm extends FormGroup {
    constructor(formGroupParams: { [key: string]: AbstractControl } = {}) {
        super(formGroupParams);
    }
    submitted = false;
}
